<div id="ff" class="button">{{ svg "10sekF" 44 "icon"}}</div>
